import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { createStyleSheet } from "../utils/styles";
import { useTranslation } from "react-i18next";

const UnsavedChangesDialog = (props: {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
}) => {
  const { open, onClose, onDiscard } = props;
  const { t } = useTranslation("UnsavedChangesDialog");

  return (
    // Don't trap focus, so the floating call panel stays usable while this is open.
    <Dialog open={open} onClose={onClose} disableEnforceFocus>
      <DialogTitle>{t("title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("body")}</DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.dialogButtonContainer}>
        <Button autoFocus onClick={onClose}>
          {t("stay")}
        </Button>
        <Button onClick={onDiscard}>{t("discard")}</Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = createStyleSheet({
  dialogButtonContainer: {
    px: 3,
    marginBottom: 1,
  },
});

export default UnsavedChangesDialog;
